import { Component, OnInit, Input, ViewChild} from '@angular/core';
import { MarketingContentFieldsComponent } from '../../marketing-content-fields/marketing-content-fields.component';
import * as CONSTANTS  from '../../../constants';

@Component({
  selector: 'pru-marketing-messages-three-column',
  templateUrl: './marketing-messages-three-column.component.html',
  styleUrls: ['./marketing-messages-three-column.component.scss']
})
export class MarketingMessagesThreeColumnComponent implements OnInit {
  @ViewChild('marketingContentFieldsComponent') marketingContentFieldsComponent: MarketingContentFieldsComponent;

  @Input() columnContent:any[];
  @Input() marketingTheme:string;
  @Input() retirementLink:string;
  shortTitleFirstColumn:string;
  longTitleFirstColumn:string;
  shortTitleSecondColumn:string;
  longTitleSecondColumn:string;
  shortTitleThirdColumn:string;
  longTitleThirdColumn:string;
  hasLongShortTitle:boolean = false;
  hasShortTitle:boolean = false;
  hasLongTitle:boolean = false;
  hasPreTitle:boolean=false;

  constructor() { }

  ngOnInit() {
    this.checkForPreTitle();
    this.checkForShortLongTitle();
  }

   /*
    This function will check if pre title 1 
    is present/not for each column
  */
 checkForPreTitle():void{
  if((this.columnContent[0][CONSTANTS.PRE_TITLE_1]!=null 
     && this.columnContent[0][CONSTANTS.PRE_TITLE_1].length>0)
     ||(this.columnContent[1][CONSTANTS.PRE_TITLE_1]!=null 
      && this.columnContent[1][CONSTANTS.PRE_TITLE_1].length>0)
      ||(this.columnContent[2][CONSTANTS.PRE_TITLE_1]!=null 
        && this.columnContent[2][CONSTANTS.PRE_TITLE_1].length>0))
      this.hasPreTitle = true;
}


   /*
    This function will check if short title 1 or long title 1
    is present/not for each column
  */
  checkForShortLongTitle():void{
    this.shortTitleFirstColumn = this.columnContent[0][CONSTANTS.SHORT_TITLE_1];
    this.longTitleFirstColumn = this.columnContent[0][CONSTANTS.LONG_TITLE_1];
    this.shortTitleSecondColumn = this.columnContent[1][CONSTANTS.SHORT_TITLE_1];
    this.longTitleSecondColumn = this.columnContent[1][CONSTANTS.LONG_TITLE_1];
    this.shortTitleThirdColumn = this.columnContent[2][CONSTANTS.SHORT_TITLE_1];
    this.longTitleThirdColumn = this.columnContent[2][CONSTANTS.LONG_TITLE_1];
    if(this.shortTitleFirstColumn != "" || this.shortTitleSecondColumn!= ""
      || this.longTitleFirstColumn != "" || this.longTitleSecondColumn != ""
        || this.shortTitleThirdColumn != "" || this.longTitleThirdColumn!="" ){
        this.hasLongShortTitle = true;
      if(this.shortTitleFirstColumn != "" || this.shortTitleSecondColumn!= ""
          || this.shortTitleThirdColumn !="") {
        this.hasShortTitle = true;
      }
      if(this.longTitleFirstColumn != "" || this.longTitleSecondColumn != ""
          || this.longTitleThirdColumn !="") {
      this.hasLongTitle = true;
      }
    }
  }

}
